'use strict';
import {getCollection, getId} from '../../core-utilities/domain/ReduxUtils';


AvatarUploadDirective.$inject = [
  '$window',
  '$toast',
  'TOAST_TYPES',
  'FilePickerFactory',
  'PersistentUploaderFactory',
  'DeviceServices',
  'FILE_USAGE',
];

export function AvatarUploadDirective(
  $window,
  $toast,
  TOAST_TYPES,
  FilePickerFactory,
  PersistentUploaderFactory,
  DeviceServices,
  FILE_USAGE,
) {
  return {
    require: ['avatar', 'onFileDrop'],
    link: function postLink($scope, $element, $attrs, controllers) {
      const avatarCtrl = controllers[0];
      const dropCtrl = controllers[1];
      let filePicker;
      let uploader;
      const vm = avatarCtrl;
      vm.onFileSelect = onFileSelect;

      // TODO: add support for banners?
      uploader = PersistentUploaderFactory({
        getFilename: getModelId,
        generateFileRequest: generateFileRequest,
        getModelId: getModelId,
        usage: FILE_USAGE.AVATAR,

        onSuccess: 'get("$domain").getDomain(collection).$setAvatar(id, fileDomain)',
        getLocals: function () {
          return {
            id: getId(vm.model),
            collection: getCollection(vm.model),
          }
        },

        afterUploadStarted: afterUploadStarted
      });

      filePicker = FilePickerFactory($scope, {
        getNewFilePath: getFilePath,
        getNewFileName: getModelId,
        onSuccess: DeviceServices.supportsCamera() ? uploader.onSuccess : onFileSelect,
        onError: uploader.onError
      });

      $attrs.$observe('avatarUpload', function (newValue) {
        if (newValue === true || newValue === 'true')
          enableUploads();
        else
          disableUploads();
      });

      $scope.$on('$destroy', cleanup);

      // TODO:un-comment the DnD upload handler once avatar uploads has been updated
      function enableUploads() {
        // if (!DeviceServices.isWebView())
        //   dropCtrl.setFileHandler(onFileSelect);
        $element.on('click', onClick);
      }

      function disableUploads() {
        // if (!DeviceServices.isWebView())
        //   dropCtrl.setFileHandler(angular.noop);
        $element.off('click', onClick);
      }

      function onClick() {
        $toast.showMessage('Uploading avatars is temporarily disabled', null, TOAST_TYPES.warning);

        //if (DeviceServices.supportsCamera()) {
        //  //on mobile, offer to open the camera or file select menu
        //  filePicker.showMobileUploadMenu(false);
        //} else {
        //  // TODO: show modal with option to replace, and then show preview, and crop
        //  // on desktop immediately open the file dialog
        //  filePicker.pickFile(false, false);
        //}
      }

      // show the in upload in progress
      function afterUploadStarted(fileData, file, key) {
        avatarCtrl.showAvatar();
        if (fileData.fileUri) {
          avatarCtrl.setAvatarUrl(fileData.fileUri);
        } else if ($window.FileReader) {
          const fileReader = new $window.FileReader();

          fileReader.onload = function onload(event) {
            avatarCtrl.setAvatarUrl(event.target.result);
          };

          fileReader.readAsDataURL(file);
        }
      }

      function onFileSelect(files) {
        //console.log('AvatarUploadDirective.onFileSelect', files);
        const file = files && files.length ? files[0] : files;
        if (!file) return;

        uploader.onSuccess({
          file: file
        });
      }

      function getModelId() {
        return getId(vm.model);
      }

      function generateFileRequest() {
        return {
          path: getFilePath(),
          filename: getModelId(),
          firebasePath: getCollection(vm.model),
        }
      }

      function getFilePath() {
        return 'avatars/' + getId(vm.model);
      }

      function cleanup() {
        $element.off('click', onClick);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/files/directives/AvatarUploadDirective.js